import React from 'react';

interface TableBodyProps {
    children: React.ReactNode;
}

const TableBody: React.FC<TableBodyProps> = (props) => {
    const { children } = props;
    return <tbody>{children}</tbody>;
};

export default TableBody;
